import React from "react";
import styles from "./demographics.module.css";
import { Section, SectionIntro } from "../../../../COMPONENTS/UI";
import Reveal from "../../../../COMPONENTS/ANIMATION/Reveal";
import BarList from "../../../../COMPONENTS/BAR_LIST";
import { demographics, specialtyPopulations } from "../../../../CONTENT/sponsors";

const Demographics = () => (
  <Section tone="light" id="demographics" labelledBy="demographics-title">
    <SectionIntro
      id="demographics-title"
      eyebrow="Demographics"
      title="The populations our sites reach."
      lead="Share of KUR patients by age, sex, ethnicity and race."
    />

    <div className={styles.charts}>
      {demographics.map((d, i) => (
        <Reveal key={d.title} delay={(i % 2) * 0.08}>
          <BarList title={d.title} rows={d.rows} />
        </Reveal>
      ))}
    </div>

    <div className={styles.special}>
      <h3 className={styles.specialTitle}>Specialty populations</h3>
      <ul className={styles.specialList}>
        {specialtyPopulations.map((p) => (
          <li key={p.title} className={p.text ? styles.wide : undefined}>
            <strong>{p.title}</strong>
            {p.text && <p>{p.text}</p>}
          </li>
        ))}
      </ul>
    </div>
  </Section>
);

export default Demographics;
